var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0835 14.2502H11.9168V16.0835H10.0835V14.2502ZM10.0835 6.91683H11.9168V12.4168H10.0835V6.91683ZM10.991 2.3335C5.931 2.3335 1.8335 6.44016 1.8335 11.5002C1.8335 16.5602 5.931 20.6668 10.991 20.6668C16.0602 20.6668 20.1668 16.5602 20.1668 11.5002C20.1668 6.44016 16.0602 2.3335 10.991 2.3335ZM11.0002 18.8335C6.9485 18.8335 3.66683 15.5518 3.66683 11.5002C3.66683 7.4485 6.9485 4.16683 11.0002 4.16683C15.0518 4.16683 18.3335 7.4485 18.3335 11.5002C18.3335 15.5518 15.0518 18.8335 11.0002 18.8335Z",
    fill: "#DC0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.71aafab99e019fbd8089558a8ad3d59e.svg";
export { ForwardRef as ReactComponent };